import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import { doc, getDoc } from "firebase/firestore";

const actions = {
    async createProject(_, project) {
        project.createdAt = firebase.firestore.FieldValue.serverTimestamp()
        project.userId = firebase.auth().currentUser.uid
        project.public = false
        const doc_ref = await firebase.firestore().collection(`projects`).add(project)
        return doc_ref.id
    },
    async deleteProject(_, {projectId, datasetId, models}) {
      
      
        await firebase.firestore().doc(`projects/${projectId}`).delete()
  
        for (let idx in models){
          
          await firebase.firestore().doc(`models/${models[idx]}`).delete()
        }
        
        
        await firebase.firestore().doc(`datasets/${datasetId}`).delete()
  
        
    },
    updateProject(_, { projectId, update }) {
        update.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
        firebase.firestore().doc(`projects/${projectId}`).update(update)
    },
    addDatasetToProject(_, {projectId, update}) {
        firebase.firestore().doc(`projects/${projectId}`).update(update)
    },
    addModelToProject(_, {projectId, add}) {
        firebase.firestore().doc(`projects/${projectId}`).update(add)
    },
    triggerTraining(_, {projectId}) {
      firebase.firestore().doc(`projects/${projectId}`).update({
        'state.train.status': 'triggering'
      })
    },
    currentProject: firestoreAction(({ bindFirestoreRef }, projectId) => {
        
        let currentProject = firebase.firestore().doc(`projects/${projectId}`);
        
        return bindFirestoreRef('project', currentProject, {wait: true})
    }),
    newProject: firestoreAction(({ bindFirestoreRef }, projectId) => {
        
        let newProject = firebase.firestore().doc(`projects/${projectId}`);
        
        return bindFirestoreRef('newProject', newProject, {wait: true})
    }),
    retrieveAllProjects: firestoreAction(({ bindFirestoreRef, state }, currentUser) => {
        if (state.projects) {
          return
        }
        let userIds = [firebase.auth().currentUser.uid]
        if (currentUser != undefined){
            userIds = [currentUser.id]
            if (currentUser.organizationId != undefined){
                userIds.push(currentUser.organizationId)
            }
        }

        return bindFirestoreRef('projects', 
          firebase.firestore().collection(`projects`)
          .where('userId', 'in', userIds)
          .where('draft', '==', false)
          .orderBy('draft', 'desc')
          .orderBy('createdAt', 'desc')
        )
    }),
    currentProjectLogging: firestoreAction(({ bindFirestoreRef, state }, projectId) => {
        let stateKey = `logging-${projectId}`
        
        if (state[stateKey] != undefined && state[stateKey].length > 0) {
          return
        }
        
        return bindFirestoreRef(stateKey, 
          firebase.firestore().collection(`projects/${projectId}/logging`)
          .orderBy("createdAt", "desc")
        )
    }),
    retrieveAllPublicProjects: firestoreAction(({ bindFirestoreRef, state }) => {
      if (state.projectsPublic) {
        return
      }
      return bindFirestoreRef('projectsPublic', 
        firebase.firestore().collection(`projects`)
        .where('public', '==', true)
        .orderBy('createdAt', 'desc')
      )
    }),
    
}

export default actions